<div class="aeg-admin-invoices-tab">
    <div class="aeg-u-bg-alt aeg-u-box-padding">
        <div class="aeg-u-bg-white aeg-u-box-padding">
            <aeg-search-invoice @search="onSearch" :default-query="defaultSearchQuery" :enable-document-type-filter="false" :enable-customer-reference-filter="false" :enable-service-filter="true" />
        </div>
    </div>

    <aeg-invoices-table
        :invoices="invoices?.pagedResult"
        :is-loading="isLoading"
        :download-file-uri="invoices?.downloadUrl"
        :show-download-link="showDownloadLink"
        :show-service="true"
        :show-customer-reference="false"
        :show-document-type="false"
        :show-paid="false"
        :show-actor="true"
        @change-page="goToPage"
    />

</div>


